import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import {faStar} from '@fortawesome/free-solid-svg-icons/faStar';
import PulsoidClient from '../../PulsoidClient';
import {Action, ActionHref, Help} from '../../system/buttons';
import {PremiumFeatureDescription} from '../../system/FeatureDescriptionModal';
import {SaleComponent} from '../../system/sale';
import {SaleButtonClassName} from '../../system/sale';
import {LoaderWrapperLazy} from '../../system/Loader/Loader';
import {Link, withRouter} from 'react-router-dom';
import {RedeemCouponModal} from './RedeemCouponModal/RedeemCouponModal';
import {DASHBOARD_ROUTES} from '../navigation/dashboard/DashboardRoutes';
import {buildRoute} from '../navigation/navigationUtils';
import {PastDueHandling} from '../settings/PastDueHandling';

class PremiumComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  client = new PulsoidClient();

  componentDidMount() {
    this.setState({
      showRedeemModal:
        new URLSearchParams(this.props.location.search).get('action') ===
        'redeem-coupon',
    });

    this.client.getPremiumInfo().then((premium) => {
      return this.setState({premium});
    });
    this.client.getReferralStatistics().then((referralStatistics) => {
      this.setState({referralStatistics});
    });
  }

  refreshPremiumInfo = async () => {
    let premium = await this.client.getPremiumInfo();
    this.setState({premium});
  };

  handleActivateTrial() {
    this.client.activateTrial().then(() => this.refreshPremiumInfo());
  }

  premiumCard() {
    let {premium} = this.state;
    let {
      isPremium,
      isHadTrial,
      isSubscribed,
      description,
      expiresAt,
      isLifetime,
      isPastDue,
      updateUrl,
    } = premium;
    let referralStatistics = <></>;
    if (this.state.referralStatistics) {
      let statistics = this.state.referralStatistics;

      let applied = <></>;
      if (statistics.referralBonusApplied === 1) {
        applied = <div>1 bonus weeks has been applied already</div>;
      } else if (statistics.referralBonusApplied > 1) {
        applied = (
          <div>
            {statistics.referralBonusApplied} bonus weeks have been applied
            already
          </div>
        );
      }

      let available = <></>;
      if (statistics.referralProfileStreamed === 1) {
        available = <div>1 bonus week is available</div>;
      } else if (statistics.referralProfileStreamed > 1) {
        available = (
          <div>
            {statistics.referralProfileStreamed} bonus weeks are available
          </div>
        );
      }

      referralStatistics = (
        <>
          {applied}
          {available}
        </>
      );
    }

    let redeemLink = (
      <div>
        {
          <a href={'#'} onClick={this.showRedeemModal} style={{color: 'white'}}>
            Redeem coupon
          </a>
        }
      </div>
    );

    if (isPremium) {
      if (!isSubscribed) {
        return (
          <Col className="p-2">
            <Card bg="dark" className="p-3" text="white">
              <Row>
                <Col xs={3}>
                  {' '}
                  <FontAwesomeIcon size="5x" icon={faStar} />
                </Col>
                <Col xs={9} className="text-right">
                  <div className="font" style={{fontSize: '40px'}}>
                    {description} Bro plan <PremiumFeatureDescription />
                  </div>
                  <div className={'pb-1'}>
                    Expires on{' '}
                    {new Date(Date.parse(expiresAt)).toLocaleDateString()}
                  </div>
                  {redeemLink}
                  {referralStatistics}
                  <Action
                    href="https://pulsoid.net/pricing?bi.from=dashboard"
                    className={SaleButtonClassName}
                  >
                    <FontAwesomeIcon icon={faStar} /> &nbsp; Upgrade to BRO Plan{' '}
                    <SaleComponent />
                  </Action>
                </Col>
              </Row>
            </Card>
          </Col>
        );
      } else {
        return (
          <Col className="p-2">
            <Card
              style={{backgroundColor: '#11A2B1'}}
              className="p-3"
              text="white"
            >
              <Row>
                <Col xs={3}>
                  {' '}
                  <FontAwesomeIcon size="5x" icon={faStar} />
                </Col>
                <Col xs={9} className="text-right">
                  <div className="font" style={{fontSize: '40px'}}>
                    BRO plan <PremiumFeatureDescription />
                  </div>
                  {referralStatistics}
                  {expiresAt && (
                    <div>
                      Renewal date:{' '}
                      {new Date(Date.parse(expiresAt)).toLocaleDateString()}
                    </div>
                  )}
                  {isLifetime ? '' : redeemLink}
                  <PastDueHandling
                    isPastDue={isPastDue}
                    updateUrl={updateUrl}
                  />
                  {isLifetime ? (
                    ''
                  ) : (
                    <div>
                      <Link
                        to={buildRoute({
                          path: DASHBOARD_ROUTES.CANCEL_SUBSCRIPTION,
                        })}
                        style={{color: 'white'}}
                      >
                        {' '}
                        Cancel subscription
                      </Link>
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
          </Col>
        );
      }
    } else {
      if (isHadTrial) {
        return (
          <Col className="p-2">
            <Card bg="dark" className="p-3" text="white">
              <Row>
                <Col xs={3}>
                  {' '}
                  <FontAwesomeIcon size="5x" icon={faStar} />
                </Col>
                <Col xs={9} className="text-right">
                  <div className="font" style={{fontSize: '40px'}}>
                    Free plan <PremiumFeatureDescription />
                  </div>
                  {redeemLink}
                  {referralStatistics}
                  <ActionHref
                    href="https://pulsoid.net/pricing?bi.from=dashboard"
                    className={SaleButtonClassName}
                  >
                    Upgrade to BRO Plan <SaleComponent />
                  </ActionHref>
                </Col>
              </Row>
            </Card>
          </Col>
        );
      } else {
        return (
          <Col className="p-2">
            <Card bg="dark" className="p-3" text="white">
              <Row>
                <Col xs={3}>
                  {' '}
                  <FontAwesomeIcon size="5x" icon={faStar} />
                </Col>
                <Col xs={9} className="text-right">
                  <div className="font" style={{fontSize: '40px'}}>
                    Free plan <PremiumFeatureDescription />
                  </div>
                  {redeemLink}
                  {referralStatistics}
                  <Action
                    href="https://pulsoid.net/pricing?bi.from=dashboard"
                    className={SaleButtonClassName}
                  >
                    <FontAwesomeIcon icon={faStar} /> &nbsp; Upgrade to BRO Plan{' '}
                    <SaleComponent />
                  </Action>{' '}
                  or <span> </span>
                  <Help onClick={this.handleActivateTrial.bind(this)}>
                    Activate trial
                  </Help>
                </Col>
              </Row>
            </Card>
          </Col>
        );
      }
    }
  }

  render() {
    let {premium} = this.state;
    return (
      <>
        <LoaderWrapperLazy
          description={'Initializing...'}
          loading={!premium}
          lazyChildren={() => <Row>{this.premiumCard()}</Row>}
        />
        {this.state.showRedeemModal ? (
          <RedeemCouponModal
            show={true}
            onClose={this.closeRedeemModal}
            onCouponApplied={this.refreshPremiumInfo}
          />
        ) : null}
      </>
    );
  }

  showRedeemModal = () => {
    this.setState({showRedeemModal: true});
  };

  closeRedeemModal = () => {
    this.setState({showRedeemModal: false});
    this.props.history?.replace(
      buildRoute({path: DASHBOARD_ROUTES.DASHBOARD, query: ''})
    );
  };
}

export const Premium = withRouter(PremiumComponent);
